import { render } from "./nonacademiccandidatelist.vue?vue&type=template&id=597e27a4"
import script from "./nonacademiccandidatelist.vue?vue&type=script&lang=js"
export * from "./nonacademiccandidatelist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__